import React from 'react'

const TablaOtrosParticipantesMedicosDQX = ({item,passInfoMedicos}) => {
    const body={
        codigoMedigo:item.MMCODM,
        nombreMedico:item.MMNomM,
        codigoEspecialidad:item.MECodE,
        nombreEspecialidad:item.MENomE
    }
    const handleClickMedico=()=>{
        passInfoMedicos(body)
    }
  return (
    <tr className="border-b" >
        <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
        <button
            onClick={handleClickMedico}
          type="button"
          className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
        >
          Seleccionar
        </button>
      </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap text-left">
            {item.MMCODM}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap text-left">
            {item.MMNomM}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap text-left">
            {item.MMCedM}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap text-left">
            {item.MENomE}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap text-left">
            {item.MECodE}
        </td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap text-left">
            {item.MMRegM}
        </td>
    </tr>
  )
}

export default TablaOtrosParticipantesMedicosDQX